// pages/About.js
import React from "react";
import { FaTrophy, FaLightbulb } from "react-icons/fa";
import "./About.css";
import tlahgul from "../../assets/images/TalhaGul.webp";
import hashir from "../../assets/images/hashir.webp";
import faizan from "../../assets/images/faizan.webp";
import aboutStoryImage from "../../assets/images/team/about-story.webp";
const About = () => {
  // Members without a photo show their initials instead
  const placeholder = null;
  const getInitials = (name) =>
    name.split(" ").filter(Boolean).slice(-2).map((part) => part[0]).join("");

  const teamMembers = [
    {
      id: 1,
      name: "Muhammad Talha Gul",
      role: "Founder & CEO",
      experience: "6+ years",
      expertise: [
        "React.js",
        "Next.js",
        "Node.js",
        "Laravel",
        "Jsx",
        "AWS",
        "Leadership",
      ],
      image: tlahgul,
    },
    {
      id: 2,
      name: "Muhammad Shoaib Gul",
      role: "Lead UI/UX Designer/Developer",
      experience: "5+ years",
      expertise: [
        "HTML",
        "CSS",
        "JavaScript",
        "Figma",
        "Adobe XD",
        "User Research",
        "Prototyping",
      ],
      image: placeholder,
    },
    {
      id: 3,
      name: "Hashir Tallet",
      role: "Digital Marketing Expert", // Corrected spelling
      experience: "4+ years",
      expertise: ["SEO", "Social Media", "Content Strategy", "Analytics"],
      image: hashir,
    },
    {
      id: 4,
      name: "Faizan Kaleem",
      role: "Senior Laravel Developer",
      experience: "4+ years",
      expertise: ["Laravel", "PHP", "MySQL", "API Development"],
      image: faizan,
    },
  ];
  

  const stats = [
    { value: "100+", label: "Projects Completed" },
    { value: "98%", label: "Client Satisfaction" },
    { value: "50+", label: "Happy Clients" },
    { value: "5+", label: "Years Experience" },
  ];

  return (
    <section id="about" className="section about">
      <div className="animated-bg">
        <div className="bg-grid"></div>
      </div>

      <div className="container">
        {/* Company Story - YOUR ORIGINAL CONTENT */}
        <div className="about-story">
          <div className="story-content">
            <h2 className="section-title">Our Story</h2>
            <div className="story-text">
              <p>
                Founded in 2021, <strong>GForce Solutions</strong> began with a
                simple mission: to help businesses transform their digital
                presence through exceptional web development. What started as a
                small team of passionate developers has grown into a
                full-service digital agency trusted by companies worldwide.
              </p>
              <p>
                We believe that great websites aren't just about code—they're
                about creating experiences that connect, engage, and convert.
                Every project we undertake is driven by our commitment to
                innovation, quality, and client success.
              </p>
              <p>
                Today, we're proud to have delivered over 250 successful
                projects, helping businesses from startups to enterprises
                achieve their digital goals.
              </p>
            </div>
          </div>
          <div className="story-image">
            <div className="image-container">
              <img
                src={aboutStoryImage}
                alt="GForce Solutions Team"
                width="600"
                height="400"
                loading="lazy"
                decoding="async"
              />
            </div>
          </div>
        </div>

        {/* Stats Section - YOUR ORIGINAL CONTENT */}
        <div className="about-stats">
          {stats.map((stat, index) => (
            <div key={index} className="stat-card">
              <div className="stat-value">{stat.value}</div>
              <div className="stat-label">{stat.label}</div>
            </div>
          ))}
        </div>

        {/* Mission & Vision - YOUR ORIGINAL CONTENT */}
        <div className="mission-vision">
          <div className="mission card">
            <div className="mission-icon">
              <FaTrophy />
            </div>
            <h3>Our Mission</h3>
            <p>
              To empower businesses with cutting-edge web solutions that drive
              growth, enhance user experiences, and deliver measurable results
              through innovative technology and strategic thinking.
            </p>
          </div>

          <div className="vision card">
            <div className="vision-icon">
              <FaLightbulb />
            </div>
            <h3>Our Vision</h3>
            <p>
              To be the most trusted partner for digital transformation,
              recognized globally for our technical excellence, creative
              solutions, and unwavering commitment to client success.
            </p>
          </div>
        </div>

        {/* Team Section - YOUR ORIGINAL CONTENT */}
        <div className="team-section">
          <h2>Meet Our Team</h2>
          <div className="team-grid">
            {teamMembers.map((member) => (
              <div key={member.id} className="team-member card">
                <div className="member-image">
                  {member.image ? (
                    <img src={member.image} alt={member.name} loading="lazy" decoding="async" />
                  ) : (
                    <div className="member-initials">{getInitials(member.name)}</div>
                  )}
                </div>
                <div className="member-info">
                  <div className="member-name">{member.name}</div>
                  <div className="member-role">{member.role}</div>
                  <div className="member-experience">
                    {member.experience} Experience
                  </div>
                  <div className="member-expertise">
                    {member.expertise.map((skill, index) => (
                      <span key={index} className="expertise-tag">
                        {skill}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
